/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/slave-server/protocol-configuration': {
    put: {
      minApiVersion: 2.1,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/SlaveServerRawConfig',
      },
    },
  },
};
